import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3241d8fc = () => interopDefault(import('../pages/2024bbq.vue' /* webpackChunkName: "pages/2024bbq" */))
const _059ca9ea = () => interopDefault(import('../pages/2024bbq-thanks.vue' /* webpackChunkName: "pages/2024bbq-thanks" */))
const _13f9f48a = () => interopDefault(import('../pages/aspenridgeHomes.vue' /* webpackChunkName: "pages/aspenridgeHomes" */))
const _da583d0e = () => interopDefault(import('../pages/bf-ns-thankyou.vue' /* webpackChunkName: "pages/bf-ns-thankyou" */))
const _65ddd716 = () => interopDefault(import('../pages/bf-ns-thankyou-test.vue' /* webpackChunkName: "pages/bf-ns-thankyou-test" */))
const _39c81ce2 = () => interopDefault(import('../pages/bf-ppc-lp.vue' /* webpackChunkName: "pages/bf-ppc-lp" */))
const _5f83646c = () => interopDefault(import('../pages/bf-ppc-lp-Hubspot.vue' /* webpackChunkName: "pages/bf-ppc-lp-Hubspot" */))
const _76648eb5 = () => interopDefault(import('../pages/bf-ppc-lp-old-staging-version.vue' /* webpackChunkName: "pages/bf-ppc-lp-old-staging-version" */))
const _39258648 = () => interopDefault(import('../pages/bf-ppc-lp-staging-v1.vue' /* webpackChunkName: "pages/bf-ppc-lp-staging-v1" */))
const _54eb8cf7 = () => interopDefault(import('../pages/bh-brokerportal.vue' /* webpackChunkName: "pages/bh-brokerportal" */))
const _53e75c40 = () => interopDefault(import('../pages/brookfieldHomes.vue' /* webpackChunkName: "pages/brookfieldHomes" */))
const _2033485d = () => interopDefault(import('../pages/homeowner-fall-bbq.vue' /* webpackChunkName: "pages/homeowner-fall-bbq" */))
const _564b7995 = () => interopDefault(import('../pages/homeowner-fall-bbq-thankyou.vue' /* webpackChunkName: "pages/homeowner-fall-bbq-thankyou" */))
const _32690a00 = () => interopDefault(import('../pages/index-Feb1_2023.vue' /* webpackChunkName: "pages/index-Feb1_2023" */))
const _994c6252 = () => interopDefault(import('../pages/index-jun-29-2020-backup.vue' /* webpackChunkName: "pages/index-jun-29-2020-backup" */))
const _5389a392 = () => interopDefault(import('../pages/index-old.vue' /* webpackChunkName: "pages/index-old" */))
const _2e956d9c = () => interopDefault(import('../pages/index-old-2.vue' /* webpackChunkName: "pages/index-old-2" */))
const _6abf324b = () => interopDefault(import('../pages/index-staging.vue' /* webpackChunkName: "pages/index-staging" */))
const _af3ae330 = () => interopDefault(import('../pages/register.vue' /* webpackChunkName: "pages/register" */))
const _284d755e = () => interopDefault(import('../pages/register_CM.vue' /* webpackChunkName: "pages/register_CM" */))
const _485ed352 = () => interopDefault(import('../pages/safety.vue' /* webpackChunkName: "pages/safety" */))
const _26672c14 = () => interopDefault(import('../pages/singles.vue' /* webpackChunkName: "pages/singles" */))
const _6834d6f2 = () => interopDefault(import('../pages/sitetable.vue' /* webpackChunkName: "pages/sitetable" */))
const _7cc1f3ba = () => interopDefault(import('../pages/thankyou.vue' /* webpackChunkName: "pages/thankyou" */))
const _53100a32 = () => interopDefault(import('../pages/thankyou-bf.vue' /* webpackChunkName: "pages/thankyou-bf" */))
const _28ad5830 = () => interopDefault(import('../pages/thankyou-ns.vue' /* webpackChunkName: "pages/thankyou-ns" */))
const _2757e962 = () => interopDefault(import('../pages/towerhillHomes.vue' /* webpackChunkName: "pages/towerhillHomes" */))
const _b4aa79aa = () => interopDefault(import('../pages/blogs/a-new-fitter-healthier-you.vue' /* webpackChunkName: "pages/blogs/a-new-fitter-healthier-you" */))
const _4fd075c6 = () => interopDefault(import('../pages/blogs/activities-at-petticoat.vue' /* webpackChunkName: "pages/blogs/activities-at-petticoat" */))
const _08e00582 = () => interopDefault(import('../pages/blogs/adorable-antique-shops-in-the-pickering-area.vue' /* webpackChunkName: "pages/blogs/adorable-antique-shops-in-the-pickering-area" */))
const _2a5d7e9a = () => interopDefault(import('../pages/blogs/college-close-to-home.vue' /* webpackChunkName: "pages/blogs/college-close-to-home" */))
const _0318eab2 = () => interopDefault(import('../pages/blogs/enjoy-life-on-the-water-near-new-seaton.vue' /* webpackChunkName: "pages/blogs/enjoy-life-on-the-water-near-new-seaton" */))
const _5626f1ea = () => interopDefault(import('../pages/blogs/event-listing-artfest-on-the-esplanade.vue' /* webpackChunkName: "pages/blogs/event-listing-artfest-on-the-esplanade" */))
const _21755d7f = () => interopDefault(import('../pages/blogs/five-must-play-golf-courses-in-pickering.vue' /* webpackChunkName: "pages/blogs/five-must-play-golf-courses-in-pickering" */))
const _1718b277 = () => interopDefault(import('../pages/blogs/getting-around-at-new-seaton.vue' /* webpackChunkName: "pages/blogs/getting-around-at-new-seaton" */))
const _13c6c312 = () => interopDefault(import('../pages/blogs/great-grown-up-birthday-party-ideas-in-pickering.vue' /* webpackChunkName: "pages/blogs/great-grown-up-birthday-party-ideas-in-pickering" */))
const _028c3072 = () => interopDefault(import('../pages/blogs/higher-living-meets-high-education.vue' /* webpackChunkName: "pages/blogs/higher-living-meets-high-education" */))
const _846ec348 = () => interopDefault(import('../pages/blogs/march-break-madness-activities-kids-will-love.vue' /* webpackChunkName: "pages/blogs/march-break-madness-activities-kids-will-love" */))
const _3a4b3bc9 = () => interopDefault(import('../pages/blogs/new-approach-to-complete-community-design.vue' /* webpackChunkName: "pages/blogs/new-approach-to-complete-community-design" */))
const _0a7680dc = () => interopDefault(import('../pages/blogs/new-seaton-featured-in-the-toronto-sun.vue' /* webpackChunkName: "pages/blogs/new-seaton-featured-in-the-toronto-sun" */))
const _0b51187e = () => interopDefault(import('../pages/blogs/new-ways-to-have-fun-this-family-day-in-pickering.vue' /* webpackChunkName: "pages/blogs/new-ways-to-have-fun-this-family-day-in-pickering" */))
const _afedad52 = () => interopDefault(import('../pages/blogs/our-5-favourite-things-to-do-at-rouge-national-urban-park.vue' /* webpackChunkName: "pages/blogs/our-5-favourite-things-to-do-at-rouge-national-urban-park" */))
const _74533ec6 = () => interopDefault(import('../pages/blogs/petapolooza-pickering.vue' /* webpackChunkName: "pages/blogs/petapolooza-pickering" */))
const _1d36bc70 = () => interopDefault(import('../pages/blogs/pickering-summer-concert-series.vue' /* webpackChunkName: "pages/blogs/pickering-summer-concert-series" */))
const _ffc439a4 = () => interopDefault(import('../pages/blogs/six-spots-you-need-to-try-in-downtown-pickering.vue' /* webpackChunkName: "pages/blogs/six-spots-you-need-to-try-in-downtown-pickering" */))
const _66eefa08 = () => interopDefault(import('../pages/blogs/the-best-community-facilities-near-new-seaton.vue' /* webpackChunkName: "pages/blogs/the-best-community-facilities-near-new-seaton" */))
const _13d71b96 = () => interopDefault(import('../pages/blogs/the-best-micro-breweries.vue' /* webpackChunkName: "pages/blogs/the-best-micro-breweries" */))
const _02fd4923 = () => interopDefault(import('../pages/blogs/top-shopping.vue' /* webpackChunkName: "pages/blogs/top-shopping" */))
const _2a261ddf = () => interopDefault(import('../pages/blogs/top-vendors-at-pickering-farmers-market.vue' /* webpackChunkName: "pages/blogs/top-vendors-at-pickering-farmers-market" */))
const _6e76e35c = () => interopDefault(import('../pages/blogs/whats-new-at-the-zoo.vue' /* webpackChunkName: "pages/blogs/whats-new-at-the-zoo" */))
const _6b04c245 = () => interopDefault(import('../pages/highlight/award-winning-builders.vue' /* webpackChunkName: "pages/highlight/award-winning-builders" */))
const _901e8268 = () => interopDefault(import('../pages/highlight/community-vision.vue' /* webpackChunkName: "pages/highlight/community-vision" */))
const _294cbe50 = () => interopDefault(import('../pages/highlight/new-home-types.vue' /* webpackChunkName: "pages/highlight/new-home-types" */))
const _7166550c = () => interopDefault(import('../pages/highlight/new-parks.vue' /* webpackChunkName: "pages/highlight/new-parks" */))
const _6d76d080 = () => interopDefault(import('../pages/highlight/new-retail-shops.vue' /* webpackChunkName: "pages/highlight/new-retail-shops" */))
const _79b035fc = () => interopDefault(import('../pages/highlight/new-schools.vue' /* webpackChunkName: "pages/highlight/new-schools" */))
const _0d0eb37a = () => interopDefault(import('../pages/highlight/new-trails.vue' /* webpackChunkName: "pages/highlight/new-trails" */))
const _01227d56 = () => interopDefault(import('../pages/highlight/new-transit.vue' /* webpackChunkName: "pages/highlight/new-transit" */))
const _6bb9b2dd = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/2024bbq",
    component: _3241d8fc,
    name: "2024bbq"
  }, {
    path: "/2024bbq-thanks",
    component: _059ca9ea,
    name: "2024bbq-thanks"
  }, {
    path: "/aspenridgeHomes",
    component: _13f9f48a,
    name: "aspenridgeHomes"
  }, {
    path: "/bf-ns-thankyou",
    component: _da583d0e,
    name: "bf-ns-thankyou"
  }, {
    path: "/bf-ns-thankyou-test",
    component: _65ddd716,
    name: "bf-ns-thankyou-test"
  }, {
    path: "/bf-ppc-lp",
    component: _39c81ce2,
    name: "bf-ppc-lp"
  }, {
    path: "/bf-ppc-lp-Hubspot",
    component: _5f83646c,
    name: "bf-ppc-lp-Hubspot"
  }, {
    path: "/bf-ppc-lp-old-staging-version",
    component: _76648eb5,
    name: "bf-ppc-lp-old-staging-version"
  }, {
    path: "/bf-ppc-lp-staging-v1",
    component: _39258648,
    name: "bf-ppc-lp-staging-v1"
  }, {
    path: "/bh-brokerportal",
    component: _54eb8cf7,
    name: "bh-brokerportal"
  }, {
    path: "/brookfieldHomes",
    component: _53e75c40,
    name: "brookfieldHomes"
  }, {
    path: "/homeowner-fall-bbq",
    component: _2033485d,
    name: "homeowner-fall-bbq"
  }, {
    path: "/homeowner-fall-bbq-thankyou",
    component: _564b7995,
    name: "homeowner-fall-bbq-thankyou"
  }, {
    path: "/index-Feb1_2023",
    component: _32690a00,
    name: "index-Feb1_2023"
  }, {
    path: "/index-jun-29-2020-backup",
    component: _994c6252,
    name: "index-jun-29-2020-backup"
  }, {
    path: "/index-old",
    component: _5389a392,
    name: "index-old"
  }, {
    path: "/index-old-2",
    component: _2e956d9c,
    name: "index-old-2"
  }, {
    path: "/index-staging",
    component: _6abf324b,
    name: "index-staging"
  }, {
    path: "/register",
    component: _af3ae330,
    name: "register"
  }, {
    path: "/register_CM",
    component: _284d755e,
    name: "register_CM"
  }, {
    path: "/safety",
    component: _485ed352,
    name: "safety"
  }, {
    path: "/singles",
    component: _26672c14,
    name: "singles"
  }, {
    path: "/sitetable",
    component: _6834d6f2,
    name: "sitetable"
  }, {
    path: "/thankyou",
    component: _7cc1f3ba,
    name: "thankyou"
  }, {
    path: "/thankyou-bf",
    component: _53100a32,
    name: "thankyou-bf"
  }, {
    path: "/thankyou-ns",
    component: _28ad5830,
    name: "thankyou-ns"
  }, {
    path: "/towerhillHomes",
    component: _2757e962,
    name: "towerhillHomes"
  }, {
    path: "/blogs/a-new-fitter-healthier-you",
    component: _b4aa79aa,
    name: "blogs-a-new-fitter-healthier-you"
  }, {
    path: "/blogs/activities-at-petticoat",
    component: _4fd075c6,
    name: "blogs-activities-at-petticoat"
  }, {
    path: "/blogs/adorable-antique-shops-in-the-pickering-area",
    component: _08e00582,
    name: "blogs-adorable-antique-shops-in-the-pickering-area"
  }, {
    path: "/blogs/college-close-to-home",
    component: _2a5d7e9a,
    name: "blogs-college-close-to-home"
  }, {
    path: "/blogs/enjoy-life-on-the-water-near-new-seaton",
    component: _0318eab2,
    name: "blogs-enjoy-life-on-the-water-near-new-seaton"
  }, {
    path: "/blogs/event-listing-artfest-on-the-esplanade",
    component: _5626f1ea,
    name: "blogs-event-listing-artfest-on-the-esplanade"
  }, {
    path: "/blogs/five-must-play-golf-courses-in-pickering",
    component: _21755d7f,
    name: "blogs-five-must-play-golf-courses-in-pickering"
  }, {
    path: "/blogs/getting-around-at-new-seaton",
    component: _1718b277,
    name: "blogs-getting-around-at-new-seaton"
  }, {
    path: "/blogs/great-grown-up-birthday-party-ideas-in-pickering",
    component: _13c6c312,
    name: "blogs-great-grown-up-birthday-party-ideas-in-pickering"
  }, {
    path: "/blogs/higher-living-meets-high-education",
    component: _028c3072,
    name: "blogs-higher-living-meets-high-education"
  }, {
    path: "/blogs/march-break-madness-activities-kids-will-love",
    component: _846ec348,
    name: "blogs-march-break-madness-activities-kids-will-love"
  }, {
    path: "/blogs/new-approach-to-complete-community-design",
    component: _3a4b3bc9,
    name: "blogs-new-approach-to-complete-community-design"
  }, {
    path: "/blogs/new-seaton-featured-in-the-toronto-sun",
    component: _0a7680dc,
    name: "blogs-new-seaton-featured-in-the-toronto-sun"
  }, {
    path: "/blogs/new-ways-to-have-fun-this-family-day-in-pickering",
    component: _0b51187e,
    name: "blogs-new-ways-to-have-fun-this-family-day-in-pickering"
  }, {
    path: "/blogs/our-5-favourite-things-to-do-at-rouge-national-urban-park",
    component: _afedad52,
    name: "blogs-our-5-favourite-things-to-do-at-rouge-national-urban-park"
  }, {
    path: "/blogs/petapolooza-pickering",
    component: _74533ec6,
    name: "blogs-petapolooza-pickering"
  }, {
    path: "/blogs/pickering-summer-concert-series",
    component: _1d36bc70,
    name: "blogs-pickering-summer-concert-series"
  }, {
    path: "/blogs/six-spots-you-need-to-try-in-downtown-pickering",
    component: _ffc439a4,
    name: "blogs-six-spots-you-need-to-try-in-downtown-pickering"
  }, {
    path: "/blogs/the-best-community-facilities-near-new-seaton",
    component: _66eefa08,
    name: "blogs-the-best-community-facilities-near-new-seaton"
  }, {
    path: "/blogs/the-best-micro-breweries",
    component: _13d71b96,
    name: "blogs-the-best-micro-breweries"
  }, {
    path: "/blogs/top-shopping",
    component: _02fd4923,
    name: "blogs-top-shopping"
  }, {
    path: "/blogs/top-vendors-at-pickering-farmers-market",
    component: _2a261ddf,
    name: "blogs-top-vendors-at-pickering-farmers-market"
  }, {
    path: "/blogs/whats-new-at-the-zoo",
    component: _6e76e35c,
    name: "blogs-whats-new-at-the-zoo"
  }, {
    path: "/highlight/award-winning-builders",
    component: _6b04c245,
    name: "highlight-award-winning-builders"
  }, {
    path: "/highlight/community-vision",
    component: _901e8268,
    name: "highlight-community-vision"
  }, {
    path: "/highlight/new-home-types",
    component: _294cbe50,
    name: "highlight-new-home-types"
  }, {
    path: "/highlight/new-parks",
    component: _7166550c,
    name: "highlight-new-parks"
  }, {
    path: "/highlight/new-retail-shops",
    component: _6d76d080,
    name: "highlight-new-retail-shops"
  }, {
    path: "/highlight/new-schools",
    component: _79b035fc,
    name: "highlight-new-schools"
  }, {
    path: "/highlight/new-trails",
    component: _0d0eb37a,
    name: "highlight-new-trails"
  }, {
    path: "/highlight/new-transit",
    component: _01227d56,
    name: "highlight-new-transit"
  }, {
    path: "/",
    component: _6bb9b2dd,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
